export const GlobalFooter = ({ className = "" }: { className?: string }) => {
  return (
    <footer className="text-center text-white bg-black">
      <small className="inline-block p-3">&copy;SANNANE G.K</small>
    </footer>
  );
};
